/*
Set
localStorage.setItem("PopularBetBuildersLogs", "true")

Remove
localStorage.removeItem("PopularBetBuildersLogs")
 */

export class Logger {
  private readonly isEnabled =
    localStorage.getItem("PopularBetBuildersLogs") === "true";

  public log = (...args: unknown[]) => {
    if (this.isEnabled) {
      // eslint-disable-next-line no-console
      console.log(...args);
    }
  };

  public error = (...args: unknown[]) => {
    console.error(...args);
  };

  public warn = (...args: unknown[]) => {
    console.warn(...args);
  };
}

export const logger = new Logger();
